import { render, staticRenderFns } from "./Depart.vue?vue&type=template&id=902e7ab8&scoped=true&"
import script from "./Depart.vue?vue&type=script&lang=js&"
export * from "./Depart.vue?vue&type=script&lang=js&"
import style0 from "./Depart.vue?vue&type=style&index=0&id=902e7ab8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "902e7ab8",
  null
  
)

export default component.exports